import React from 'react';
import { FormattedMessage } from 'react-intl';
import { teamManagementUrl } from '../../../common/config';

const ErrorMessage: React.FC = () => {
  return (
    <div className='margin-vertical-xl align-center'>
      <h1 className='margin-none'>
        <FormattedMessage id='teammanagement.personalization.success.error' />
      </h1>
      <div>
        <img
          alt='errorImage'
          src='//www.static-immobilienscout24.de/statpic/error-page/1b897f0c0bc19ff74d68346f75fdef25_IS24_ErrorPage.svg'
          onError={() => "this.src='//etc/designs/is24/img/immoscout24.png';this.onerror=null;"}
          style={{ height: 200 }}
        />
        <p className='font-bold margin-bottom-s'>
          <FormattedMessage id='teammanagement.personalization.success.error.additionalInfo' />
        </p>
        <a href={teamManagementUrl()} className='button-primary margin-bottom-l'>
          <FormattedMessage id='teammanagement.personalization.success.error.button.myteam' />
        </a>
        <p>
          <FormattedMessage id='teammember.invitation.error.thankingMessage' />
        </p>
      </div>
    </div>
  );
};

export default ErrorMessage;
